import Vue from 'vue'
import VueCurrencyFilter from 'vue-currency-filter'

Vue.use(VueCurrencyFilter,
  {
    symbol: 'R$',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
  })

  Vue.use(VueCurrencyFilter,
    {
      name: 'percentual',
      symbol: '%',
      thousandsSeparator: '.',
      fractionCount: 2,
      fractionSeparator: ',',
      symbolPosition: 'front',
      symbolSpacing: false
    })



// WEBPACK FOOTER //
// ./src/bibliotecas/vue/vuecurrencyfilter.js